import { HelperCore } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';
import md5 from 'crypto-js/md5'
import axios from 'axios';
import Core from '@/common/helper/core';
import userStore from '@/store/user';
import slsLogger from '@public/log/sls';
import Loader from '@/common/helper/loader';
import globalStore from '@/store/global';
import client from '@/store/client';
import { request } from '@/common';
/**
 * 签名
 * requestdata: { qid: string, method: string, [key: string]: any }
 */
const getSign = (requestdata) => {
  const signEncode = (data) => {
    return data
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29')
      .replace(/!/g, '%21')
      .replace(/~/g, '%7E')
      .replace(/'/g, '%27')
      .replace(/,/g, '%2C')
      .replace(/%20/g, '+') // 空格问题
  }
  const objData = Object.keys(requestdata)

  objData.sort((first, two) => {
    if (first < two) return -1
    if (first > two) return 1
    return 0
  })

  const reqData = `${objData
    .reduce((pre, cur) => {
      const str = `${pre}&${cur}=${encodeURIComponent(requestdata[cur])}`

      return str
    }, '')
    .slice(1)}e7b24b112a44fdd9ee93bdf998c6ca0e`
  const sign = md5(signEncode(reqData).trim()).toString()

  return sign
}

// 卫士、网盘相关地址
const WeishiEndpoints = {
  // 本地环境
  'dev': {
    weishi: 'https://n-sim.safe.360.cn',
    cloudDisk: 'https://qaopen.eyun.360.cn',
  },
  // 测试环境
  'production': {
    weishi: 'https://n-sim.safe.360.cn',
    cloudDisk: 'https://qaopen.eyun.360.cn',
  },
  // 回归
  'online': {
    weishi: 'https://n-pre.safe.360.cn',
    // cloudDisk: 'https://hg-openapi.eyun.360.cn',
    cloudDisk: "https://openapi.eyun.360.cn",
  },
  'devonline': {
    weishi: 'https://n-pre.safe.360.cn',
    // cloudDisk: 'https://hg-openapi.eyun.360.cn',
    cloudDisk: "https://openapi.eyun.360.cn",
  },
  // 线上
  'master': {
    weishi: 'https://n.safe.360.cn',
    cloudDisk: 'https://openapi.eyun.360.cn',
  },
  'devmaster': {
    weishi: 'https://n.safe.360.cn',
    cloudDisk: 'https://openapi.eyun.360.cn',
  },
}
const ENV = import.meta.env.MODE

const httpClient = axios.create({
  baseURL: '',
})

class KnowledgeEnhanceStore {
  isFolded = false;     // 是否折叠
  is_so = true;
  isOpening = false;    // 正在打开预览
  conversationId = null;

  /** axiosInstance */
  newHttpClient = null

  get supportFold () {
    return true;
  }

  constructor (conversationId) {
    this.conversationId = conversationId;
    makeAutoObservable(this);
  }

  /**
   * 输入变化
   */
  updateData (data) {
    Object.keys(data).forEach(key => {
      let inputData = HelperCore.copyObj(data[key]);

      switch(key){
        case "type":{
          // 追问不支持收起
          if(data[key] != "flow"){
            this.isFolded = false;
          }
          break;
        }
      }

      this[key] = inputData;
    });
  }

  setFolded (isFolded) {
    this.isFolded = isFolded;
  }
  toggleFolded = () => {
    this.setFolded(!this.isFolded);
  }

  getContentType = (format) => {
    const types = {
      md: 'application/md',
      pdf: 'application/pdf',
      jpg: 'image/jpg',
      png: 'image/png',
      jpeg: 'image/jpg',
      webp: 'image/webp',
      gif: 'image/gif',
      mp3: 'audio/mpeg',
      mp4: 'video/mp4',
      wav: 'audio/wav',
      html: 'text/html',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      txt: 'text/plain',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      ppt: 'application/vnd.ms-powerpoint',
      csv: 'text/csv',
    }
    return types[format] || '';
  }

  /**
   * 云盘预览
   * @param {String} file_name
   */
  supportPreviewByEyun (file_name) {
    if(this.supportPreviewByPlugin(file_name)){
      return this.supportPreviewByEyunReal(file_name) || this.supportPreviewByWeishi(file_name);
    }

    return this.supportPreviewByEyunReal(file_name);
  }
  // 调智阅预览
  // 预览地址有可能是云盘，有可能是卫士
  // 优先判断是否调智阅预览 -> 不论调不调智阅，预览地址都分云盘和卫士两种
  supportPreviewByPlugin (file_name) {
    return file_name
      && client.supportEyunPlugin
      // && /\.(docx|doc)$/i.test(file_name)
      && this.supportPreviewByWeishi(file_name)
      && !/\.(csv)$/i.test(file_name)
  }
  // 预览地址取云盘地址
  supportPreviewByEyunReal (file_name) {
    return file_name
    && (
      ((client.isLLQ || client.isSeLLQ) && /\.(pdf|jpg|jpeg|png|webp|mp3|mp4|gif|md|webm)$/i.test(file_name))
      || (!(client.isLLQ || client.isSeLLQ) && /\.(jpg|jpeg|png|webp|mp3|mp4|gif|webm)$/i.test(file_name))
    );
  }
  /**
   * 卫士预览
   * @param {String} file_name
   */
  supportPreviewByWeishi (file_name) {
    return file_name
    && (
      ((client.isLLQ || client.isSeLLQ) && /\.(docx|doc|txt|xlsx|xls|pptx|ppt|html|csv)$/i.test(file_name))
      || (!(client.isLLQ || client.isSeLLQ) && /\.(pdf|docx|doc|txt|xlsx|xls|pptx|ppt|html|csv)$/i.test(file_name))
    );
  }

  // 在点击文档链接前先尝试走卫士网盘的逻辑
  async openWithWSCloud(userKnowledge) {
    const {file_id, file_name, folder_id} = userKnowledge;
    let ks_id = userKnowledge.ks_id;

    try {
      // 先拿 token
      const tokenResp = await this.getWeishiCloudToken()
      if (
        tokenResp.status !== 200
        || !tokenResp.data?.data?.access_token
        || !tokenResp.data?.data?.token
      ) {
        slsLogger.log({
          key : "preview",
          action : "error_token",
          ext : JSON.stringify(tokenResp),
          conversation_id : this.conversationId,
        });

        return Promise.resolve(null)
      }
      const { access_token } = tokenResp.data.data;

      // 是否我自己创建的知识库
      const knowledgeInfo = await this.getKnowledgeInfo(folder_id);
      if(!ks_id && knowledgeInfo){
        ks_id = knowledgeInfo.ks_id;
      }
      const isMyKnowledge = knowledgeInfo && knowledgeInfo.folder_id && !knowledgeInfo.ks_id;

      // 是否有预览权限
      if(!isMyKnowledge){
        const promissionResp = await this.checkEyunPermission(
          folder_id,
          access_token,
          String(userStore.uid),
        );
        if (
          promissionResp.status !== 200
          || promissionResp.data?.errno != 0
          || !promissionResp.data?.data
          || !promissionResp.data.data?.role
          || !(
            ["admin", "creator"].includes(promissionResp.data.data.role)
            || (
              ["member"].includes(promissionResp.data.data.role)
              && promissionResp.data.data.view_permission_mode == 1
            )
          )
        ) {
          slsLogger.log({
            key : "preview",
            action : "error_promission",
            ext : JSON.stringify(promissionResp),
            conversation_id : this.conversationId,
          });

          return Promise.resolve({
            errmsg : promissionResp.data?.errmsg || Loader.previewPromissionMsg,
          })
        }
      }

      // 调智阅预览
      if(this.supportPreviewByPlugin(file_name)){
        let openUrl = Loader.getFilePriviewUrl({file_id, file_name, ks_id, folder_id});
        let downloadUrl = null;

        // 调云盘取预览地址
        if(this.supportPreviewByEyunReal(file_name)){
          const previewResp = await this.getPreviewLink(
            file_id,
            'inline',
            this.getContentType(Core.getFileNameExt(file_name).toLowerCase()),
            access_token,
            String(userStore.uid),
            isMyKnowledge ? "" : ks_id,
          );
          if (
            previewResp.status !== 200
            || !previewResp.data?.data?.downloadUrl
          ) {
            slsLogger.log({
              key : "preview",
              action : "error_downloadurl",
              ext : JSON.stringify(previewResp),
              conversation_id : this.conversationId,
            });

            return Promise.resolve({
              errmsg : previewResp.data?.errmsg || "获取文件地址失败",
            })
          }
          else {
            openUrl = previewResp.data.data.downloadUrl;
            // downloadUrl 也传预览地址？
            // downloadUrl = openUrl;
          }
        }

        // 接下来拿下载地址
        if(!downloadUrl){
          const previewResp = await this.getPreviewLink(
            file_id,
            'attachment',
            this.getContentType(Core.getFileNameExt(file_name).toLowerCase()),
            access_token,
            String(userStore.uid),
            isMyKnowledge ? "" : ks_id,
          );
          if (
            previewResp.status !== 200
            || !previewResp.data?.data?.downloadUrl
          ) {
            slsLogger.log({
              key : "preview",
              action : "error_downloadurl",
              ext : JSON.stringify(previewResp),
              conversation_id : this.conversationId,
            });

            return Promise.resolve({
              errmsg : previewResp.data?.errmsg || "获取文件地址失败",
            })
          }
          else {
            downloadUrl = previewResp.data.data.downloadUrl;
          }
        }

        const params = {
          type: 'nami',
          action: 'previewWPSInAI',
          data: {
            downloadUrl,
            openUrl,
            requestData: {
              folder_id,
              file_id,
              file_name,
              ids : userKnowledge.ids || [],
            },
          }
        }

        HelperCore.log(`调用智阅预览`, params);
        window.postMessage(params, '*');

        return Promise.resolve(true);
      }

      // 接下来拿预览地址
      const previewResp = await this.getPreviewLink(
        file_id,
        'inline',
        this.getContentType(Core.getFileNameExt(file_name).toLowerCase()),
        access_token,
        String(userStore.uid),
        isMyKnowledge ? "" : ks_id,
      );
      if (
        previewResp.status !== 200
        || !previewResp.data?.data?.downloadUrl
      ) {
        slsLogger.log({
          key : "preview",
          action : "error_downloadurl",
          ext : JSON.stringify(previewResp),
          conversation_id : this.conversationId,
        });

        return Promise.resolve({
          errmsg : previewResp.data?.errmsg || "获取文件地址失败",
        })
      }

      return Promise.resolve(previewResp.data.data)
    } catch (e) {
      console.error('文件通过卫士网盘打开错误', e);

      slsLogger.log({
        key : "preview",
        action : "error_catch",
        ext : e.track || JSON.stringify(e),
        conversation_id : this.conversationId,
      });
      return Promise.resolve(null)
    }
  }

  isMyKnowledge = async (folder_id) => {
    return request.post("/knw_cloud/inRouter/v1/knowledge/datasets/detail", {
      folder_id,
    }, {
      dataIsJson : true,
      headers : {
        "Header-Tid" : Loader.getAssistantHeaderTid(),
      },
    })
    .then(res => {
      const { data } = res;
      return res.errno == 0 && data.folder_id && !data.ks_id;
    })
    .catch(() => false)
  }

  getKnowledgeInfo = async (folder_id) => {
    return request.post("/knw_cloud/inRouter/v1/knowledge/datasets/detail", {
      folder_id,
    }, {
      dataIsJson : true,
      headers : {
        "Header-Tid" : Loader.getAssistantHeaderTid(),
      },
    })
    .then(res => {
      const { data } = res;
      return data;
    })
    .catch(() => null)
  }

  getWeishiCloudToken = async () => {
    return await httpClient.request({
      url: WeishiEndpoints[ENV].weishi + '/main/v1/knowledge/cloud/token',
      method: 'post',
      withCredentials: true,
    })
  }

  getPreviewLink = async (fileId, disposition, content_type, access_token, qid, ks_id) => {
    const params = {
      qid,
      method: 'Sync.getDownLoadUrl',
      nid: fileId,
      disposition,
      content_type,
    }
    if(ks_id){
      params.file_ext = JSON.stringify({
        ks_id,
      });
    }

    return await httpClient.request({
      // 本地环境走代理
      baseURL: !['online', 'master', 'production'].includes(ENV) ? '' : WeishiEndpoints[ENV].cloudDisk,
      url: '/intf.php',
      method: 'get',
      withCredentials: false,
      params: {
        ...params,
        sign: getSign({
          access_token,
          ...params,
        }),
      },
      headers: {
        'Access-Token': access_token,
      },
    })
  }

  checkEyunPermission = async (nid, access_token, qid) => {
    return await httpClient.request({
      // 本地环境走代理
      baseURL: !['online', 'master', 'production'].includes(ENV) ? '' : WeishiEndpoints[ENV].cloudDisk,
      url: `/intf.php`,
      method: 'post',
      withCredentials: false,
      params: {
        qid,
        method : "KnowledgeShare.getInfoByNid",
        sign: getSign({
          qid,
          access_token,
          method: 'KnowledgeShare.getInfoByNid',
          nid,
        }),
      },
      data : {
        nid,
      },
      headers: {
        'Access-Token': access_token,
      },
    })
  }
  checkPermission = async (folder_id) => {
    // 是否我自己创建的知识库
    const isMyKnowledge = await this.isMyKnowledge(folder_id);
    if(isMyKnowledge){
      return true;
    }

    try {
      const tokenResp = await this.getWeishiCloudToken()
      if (
        tokenResp.status !== 200
        || !tokenResp.data?.data?.access_token
        || !tokenResp.data?.data?.token
      ) {
        slsLogger.log({
          key : "preview",
          action : "error_token",
          ext : JSON.stringify(tokenResp),
          conversation_id : this.conversationId,
        });

        return false;
      }
      const { access_token } = tokenResp.data.data;

      const promissionResp = await this.checkEyunPermission(
        folder_id,
        access_token,
        String(userStore.uid),
      );
      if (
        promissionResp.status !== 200
        || promissionResp.data?.errno != 0
        || !promissionResp.data?.data
        || !(
          ["admin", "creator"].includes(promissionResp.data.data.role)
          || (
            ["member"].includes(promissionResp.data.data.role)
            && promissionResp.data.data.view_permission_mode == 1
          )
        )
      ) {
        slsLogger.log({
          key : "preview",
          action : "error_promission",
          ext : JSON.stringify(promissionResp),
          conversation_id : this.conversationId,
        });

        return false;
      }
      return true;
    } catch (e) {
      slsLogger.log({
        key : "preview",
        action : "error_catch",
        ext : e.track || JSON.stringify(e),
        conversation_id : this.conversationId,
      });

      return false;
    }
  }

  /**
   * 打开预览中，加锁
   * @param {Boolean} isOpening
   */
  setOpening (isOpening) {
    this.isOpening = isOpening;
  }
}


export default KnowledgeEnhanceStore;
